import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Reveal, MaskedLine } from "../components/Reveal";
import PasswordField from "../components/PasswordField";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Le due password non coincidono.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err, "Link non valido o scaduto. Richiedi un nuovo link di recupero."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 lg:py-32" data-testid="reset-password-page">
      <div className="max-w-xl mx-auto">
        <MaskedLine delay={0.1}><span className="eyebrow">Accesso riservato</span></MaskedLine>
        <h1 className="mt-6 text-4xl sm:text-5xl leading-tight" data-testid="reset-title">
          <MaskedLine delay={0.25}>Imposta una nuova <em className="italic text-gold">password</em>.</MaskedLine>
        </h1>
        <Reveal delay={0.35}>
          <div className="mt-10 card-surface p-8 sm:p-10" data-testid="reset-card">
            {done ? (
              <div data-testid="reset-success">
                <p className="font-serif text-2xl text-ink">Password aggiornata.</p>
                <p className="mt-4 text-lg text-ink-muted leading-relaxed">
                  Puoi ora accedere alla tua Area Personale con la nuova password.
                </p>
                <Link to="/accedi" className="btn-primary mt-8" data-testid="reset-login-link">Vai all'accesso</Link>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-6" data-testid="reset-form">
                <PasswordField id="np-password" label="Nuova password" value={password}
                  onChange={(e) => setPassword(e.target.value)} testid="reset-password-input"
                  autoComplete="new-password" hint="Minimo 8 caratteri." />
                <PasswordField id="np-confirm" label="Conferma password" value={confirm}
                  onChange={(e) => setConfirm(e.target.value)} testid="reset-confirm-input"
                  autoComplete="new-password" />
                {error && <p className="text-sm text-bordeaux" role="alert" data-testid="reset-error">{error}</p>}
                <button type="submit" className="btn-primary w-full disabled:opacity-60" disabled={busy || !token} data-testid="reset-submit">
                  {busy ? "Salvataggio…" : "Reimposta password"}
                </button>
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
